<template>
    <div class="site__body-order-entry">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb--and-title-only" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                        <span class="breadcrumb__item-link">{{pageBreadcrumb}}</span>
                                    </li>
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>
                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Select Parts</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>	
		<div></div>
    
    </div>
    <selected-vehicle-block></selected-vehicle-block>
    <div class="block-space block-space--layout--divider-order-entry"></div>	
        <h1 class="block-header__title block-header__title-product-search">Select Parts by Category</h1>
    <expanding-selections></expanding-selections>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
</template>

<script>
import SelectedVehicleBlock from './SelectedVehicleBlock';
import ExpandingSelections from './ExpandingSelections';
import { mapGetters } from 'vuex';

export default {
  name: 'SelectParts',
  components: {
    SelectedVehicleBlock,
    ExpandingSelections
  },

  computed: {
      ...mapGetters(['storeCatalog']),
      pageBreadcrumb() {
          if(this.storeCatalog == 'PARTSLINK'){
              return "PartsLink Product Search";
          }else{
            return "WHI Product Search";
          }
      }
  }
}
</script>
